import { InitService } from './init.service';
import { APP_INITIALIZER } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { TranslateService } from '@ngx-translate/core';
import { RegionService } from './region.service';
import { SettingsService } from './settings.service';

const initServiceFactory = (service: InitService) => {
  return () => service.init();
};

export const initServiceProvider = {
  provide: APP_INITIALIZER,
  useFactory: initServiceFactory,
  deps: [InitService, StorageMap, SettingsService, RegionService, TranslateService
  ],
  multi: true
};
